<template>
    <SectionContentLayout
      :content_class="['list-group', {'has-ads': ads_visible === true && !route.query.qs}]"
      :state="viewport_controller.state.events[`${folder_id}:fetch_foreground`] "
      invalid_text='messages.list.invalid'
      invalid_icon='fas fa-inbox'
      error_text="messages.list.error"
      @errorRetry="emit('errorRetry')"
    >
        <template #close v-if="context_folder && !context_folder.main">
            <ActionButton
                @click="onActionClose()"
                class="back"
                icon="fas fa-chevron-circle-left"
                v-tooltip='"global.actions.back"'
            />
        </template>

        <template #header_success>
            <InputSelectAll v-if="messages.count === 0"
                :disabled="true"
                :checked="false"
            />

            <InputSelectAll v-else-if="messages_selection.count === messages.count || messages_selection.count === messages.folder_total"
              @selectAll="onSelectReset()"
              v-tooltip="'messages.actions.select_reset'"
              :checked="true"
            />

            <InputSelectAll v-else
              @selectAll="onSelectAll()"
              v-tooltip="'messages.actions.select_all'"
              :checked="false"
            />

            <ContentTitle  v-if="messages_selection.count === 0"
              :title="messages.folder_label"
            />

            <slot v-else>
                <span class="title">
                    <strong>{{messages_selection.count}}</strong>
                    {{Language.say('messages.list.selection.of')}}
                    <strong>{{messages.folder_total}}</strong>
                </span>
            </slot>
        </template>

        <template v-if='messages_selection.count === 0' #actions_success>
            <ActionButton v-show="messages.folder_total && SAPOMailConfig.client.folders.quick_empty[folder_id]"
                @click="onFoldersEmpty()"
                v-tooltip='"folders.actions.empty"'
                icon='far fa-folder empty-folder'
                class='clear'
            />

            <ActionButton
                @click="onMessagesRefresh()"
                :icon="viewport_controller.state.events[`${folder_id}:fetch_background`] === 'loading' ? 'fas fa-redo-alt fa-spin' : 'fas fa-redo-alt'"
                v-tooltip='"messages.actions.fetchNewAds"'
            />

            <ActionButton v-if="messages.folder_total > 0 || route.query.qs"
                @click="onMessagesSearch()"
                v-tooltip='"messages.actions.search"'
                :icon='(route.query.qs === "fullsearch") ? "fas fa-search-plus" : "fas fa-search"'
                :class="{'active' : search_visible}"
            />

            <ActionButton v-if="messages.folder_total > 0"
                @click="onMessagesFilter()"
                v-tooltip='"messages.actions.filter"'
                icon='fas fa-sort-amount-down'
                class="filter"
                :class="{'active dropdown-active' : filter_visible}"
            />

            <MoreActionsDropdown v-if="!route.query.qs && !context_folder.main"
              @moreActionsOpen="onMoreActionsOpen()"
              @moreActionsClose="null"
            >
              <template #actions>
                  <FoldersContextActions
                      state_initiator="messages_list"
                      :webmail_view="webmail_view"
                      :context_folder=context_folder
                      :total_messages="messages.folder_total"
                      :show_folder_name="false"
                      block="top_actions"
                      module="messages"
                    />
              </template>
           </MoreActionsDropdown>
        </template>

        <template #actions_over_success v-else>
            <ActionButton v-if="messages_selection.unread > 0"
                @click="onMessagesRead(messages_selection)"
                v-tooltip='"messages.actions.mark_read"'
                icon='far fa-envelope'
                :gtm="{
                  module : 'messages',
                  feature: 'message_flags',
                  block  : 'top_actions',
                  action : 'mark_read'
                }"
            />
            <ActionButton v-if ="messages_selection.read > 0"
                @click="onMessagesUnread(messages_selection)"
                v-tooltip='"messages.actions.mark_unread"'
                icon='fas fa-envelope'
                :gtm="{
                  module : 'messages',
                  feature: 'message_flags',
                  block  : 'top_actions',
                  action : 'mark_unread'
                }"
            />
            <ActionButton
                @click="onMessagesMove(messages_selection)"
                v-tooltip='"messages.actions.move_message"'
                icon='fas fa-folder-open'
                :gtm="{
                  module: 'messages',
                  feature: 'message_move_modal',
                  block  : 'top_actions',
                  action : 'open'
                }"
            />
            <ActionButton
                @click="onMessagesDelete(messages_selection)"
                v-tooltip='"messages.actions.move_trash"'
                :gtm="{
                  module: 'messages',
                  feature: 'message_delete',
                  block  : 'top_actions',
                  action : 'delete'
                }"
                icon='fas fa-trash-alt'
            />
            <ActionButton v-if="folder_id !== 'U3BhbQ'"
                @click="onMessagesSpam(messages_selection)"
                v-tooltip='"messages.actions.mark_spam"'
                icon='fas fa-shield-alt'
                :gtm="{
                  module: 'messages',
                  feature: 'message_spam',
                  block  : 'top_actions',
                  action : 'mark_spam'
                }"
            />
            <ActionButton v-if="folder_id === 'U3BhbQ'"
                @click="onMessagesNotSpam(messages_selection)"
                v-tooltip='"messages.actions.mark_not_spam"'
                icon='fas fa-ban'
                :gtm="{
                  module: 'messages',
                  feature: 'message_spam',
                  block  : 'top_actions',
                  action : 'mark_not_spam'
                }"
            />

            <DropdownList class="more-actions align-right">
                <template #select>
                    <ActionButton
                        v-tooltip='"messages.actions.more"'
                        icon='fas fa-ellipsis-v'
                    />
                </template>

                <template #options>
                    <ActionButton v-if="messages_selection.count <= limits.blacklist"
                        @click="onBlacklistEmail"
                        icon='fas fa-lock'
                        text="messages.actions.blacklist_email"
                        class="clear"
                        :gtm="{
                          module : 'messages',
                          feature: 'blacklist_modal',
                          block  : 'top_actions',
                          action : 'open'
                        }"
                    />

                    <ActionButton v-if="messages_selection.count <= limits.whitelist"
                        @click="onWhitelistEmail"
                        icon='fas fa-lock-open'
                        text="messages.actions.whitelist_email"
                        class="clear"
                        :gtm="{
                          module : 'messages',
                          feature: 'whitelist_modal',
                          block  : 'top_actions',
                          action : 'open'
                        }"
                    />
                    <ActionButton v-show="messages_selection.unflagged > 0"
                        @click="onMessagesFlag(messages_selection)"
                        icon='fas fa-bookmark'
                        text="messages.actions.mark_flagged"
                        class="clear"
                        :gtm="{
                          module: 'messages',
                          feature: 'message_flags',
                          block  : 'top_actions',
                          action : 'mark_flagged'
                        }"
                    />
                    <ActionButton v-show="messages_selection.flagged > 0"
                        @click="onMessagesUnflag(messages_selection)"
                        icon='far fa-bookmark'
                        text="messages.actions.mark_unflagged"
                        class="clear"
                        :gtm="{
                          module: 'messages',
                          feature: 'message_flags',
                          block  : 'top_actions',
                          action : 'mark_unflagged'
                        }"
                    />

                    <ActionButton
                        @click="onMessagesAddFilter(messages_selection)"
                        icon='fas fa-filter'
                        text="messages.actions.add_filter"
                        class="clear"
                          :gtm="{
                            module: 'messages',
                            feature: 'filters_form',
                            block  : 'top_actions',
                            action : 'open'
                          }"
                    />
                    <ActionButton
                        @click="onMessagesForward(messages_selection)"
                        icon='fas fa-share'
                        text="messages.actions.forward"
                        class="clear"
                          :gtm="{
                            module: 'messages',
                            feature: 'forward_form',
                            block  : 'top_actions',
                            action : 'open'
                          }"
                    />
                </template>
            </DropdownList>
        </template>

        <template #pre_content_success>
            <SectionSubHeader v-if="messages_selection.count === messages.count && messages_selection.count < messages.folder_total">
                <template #content>
                    <span class="title">
                      <strong>{{messages_selection.count}}</strong>
                      {{Language.say('messages.list.selection.messages')}}
                      <strong>{{messages.folder_total}}</strong>
                      {{Language.say('messages.list.selection.folder')}}
                      <strong class="folder">{{messages.folder_label}}</strong>.
                    </span>
                </template>

                <template #pos_content>
                  <ActionButton
                      @click="onSelectMailbox()"
                      icon='fas fa-check'
                      text="messages.list.selection.all"
                      :badge="` (${messages.folder_total})`"
                      :loading="viewport_controller.state.events[`${folder_id}:fetch_range`] === 'loading'"
                  />
                </template>
            </SectionSubHeader>

            <SectionSubHeader v-if="route.query.qs">
                <template #content>
                    <span class="title">
                      <strong>{{messages.folder_total}}</strong>
                      {{Language.say(`messages.list.search.results.${route.query.qs}`)}}
                      <strong v-if="route.query.qs  === 'quicksearch'">
                        {{route.query.qsearch}}
                      </strong>
                  </span>
                </template>

                <template #pos_content>
                    <ActionButton
                        @click="onMessagesSearchReset()"
                        icon='fas fa-times-circle'
                        class="outline"
                        :text="`messages.list.search.reset.${route.query.qs}`"
                    />
                </template>
            </SectionSubHeader>

            <SectionSubHeader v-if="folders_warning[messages.folder_id]" info_class="warning">
                <template #content>
                  {{Language.say(`messages.list.warnings.${SAPOMailConfig.client.folders.main[messages.folder_id]}`)}}
                </template>
            </SectionSubHeader>

            <!-- <SectionSubHeader info_class="action-progress">
                <template #content>
                    <span>A apagar 55 de 1550 mensagens</span>
                    <div class="flex"></div>
                    <div class="progress-bar"> -->
                        <!-- :style="'width: ' + upload.progress_percentage + '%;'"-->
                        <!-- <span
                          class="fill"
                          style="width: 55%;"
                        >
                      </span>
                    </div>
                    <ActionButton
                        icon='fas fa-times-circle'
                        class="clear"
                    />
                </template>
            </SectionSubHeader> -->
        </template>

        <template #content_success v-if="messages && messages.count > 0">
            <div id="element-list-messages">
                <GPTIframeBanner320Slot1 v-if="AccountController.showAds('GPT_IFRAME_BANNER_320_SLOT_1', folder_id) && !route.query.qs"
                    @removeAds="onRemoveAds()"
                />

                <OutbrainIframeBanner320Slot1 v-if="AccountController.showAds('OUTBRAIN_IFRAME_BANNER_320_SLOT_1', folder_id) && !route.query.qs"
                    @removeAds="onRemoveAds()"
                />

                <GPTInlineBanner320Slot1 v-if="AccountController.showAds('GPT_INLINE_BANNER_320_SLOT_1', folder_id) && !route.query.qs"
                    @removeAds="onRemoveAds()"
                />

             <MessagesListQuotaWarning />

              <template v-for='(message, message_index) in messages.items' :key="message.id">
                <div v-if="!message">
                  {{  onInvalidMessage(message_index)  }}
                </div>

                <div :key="message.id" v-else
                  v-drag-start="{
                    event: 'drag-message-list',
                    type: 'message',
                    data: message,
                  }"
                  class="list-item"
                  :class="{
                    'focus'    : true,
                    'unread'   : !message.flags.read,
                    'selected' : messages_selection.index[message.id],
                    'active'   : ((route.params.message_id === message.id && messages_selection.count === 0) || messages.outer_focus === message_index),
                    'deleted'  : messages.event_progress.events['moving'] && messages.event_progress.events['moving'].queue.index[message.id],
                  }">
                      <Swipe>
                          <template #swipe-element>
                              <div class="container" tabindex="0" :key="message.id">
                                  <MessagesListCheckbox
                                    :message_index="message_index"
                                    :message="message"
                                    :messages_selection="messages_selection"
                                    @messageSelect="onMessageSelect"
                                    @messageChange="onChangeCheckbox"
                                  />

                                  <MessagesListItem
                                    :message="message"
                                    :message_index="message_index"
                                    @messageFlag="onMessageFlag"
                                    @messageUnflag="onMessageUnflag"
                                    @messageClick="($event, message) => onMessageClick($event, message, message_index)"
                                    @messageDoubleClick="onMessageDoubleClick(message)"
                                    @messageContextMenu="onMessageContextMenu"
                                  />
                              </div>
                          </template>
                          <template #swipe-actions-left>
                              <ActionButton v-if="folder_id !== 'U3BhbQ'"
                                @touchstart.passive="onMessageTouchSpam(message)"
                                icon='fas fa-shield-alt'
                                text='messages.actions.mark_spam'
                              />
                              <ActionButton v-if="folder_id === 'U3BhbQ'"
                                  @touchstart.passive="onMessageTouchNotSpam(message)"
                                  icon='fas fa-ban'
                                  text='messages.actions.mark_not_spam'
                              />
                          </template>
                          <template #swipe-actions-right>
                              <ActionButton
                                  @touchstart.passive="onMessageTouchDelete(message)"
                                  icon='fas fa-trash-alt'
                                  text="messages.actions.move_trash"
                              />
                          </template>
                      </Swipe>
                </div>
              </template>
            </div>
            <div class="load-more" v-if="messages.count < messages.folder_total"
              :class="{'disabled': viewport_controller.state.events[`${folder_id}:fetch_next`] === 'loading'}"
              @click="onMessagesLoadMore()" >
                <p v-if="viewport_controller.state.events[`${folder_id}:fetch_next`] === 'loading'">
                    <i class="fas fa-redo-alt fa-spin"></i>
                    {{Language.say('messages.list.fetching_next')}}
                </p>

                <p v-else>
                   <i class="fas fa-chevron-down"></i>
                   {{Language.say('messages.list.fetch_next')}}
                </p>

            </div>

            <GPTInlineBanner320Slot2 v-if="AccountController.showAds('GPT_INLINE_BANNER_320_SLOT_2', folder_id) && !route.query.qs"
                @removeAds="onRemoveAds()"
            />
        </template>

        <template #content_success v-else>
            <GPTIframeBanner320Slot1 v-if="AccountController.showAds('GPT_IFRAME_BANNER_320_SLOT_1', folder_id) && !route.query.qs"
                @removeAds="onRemoveAds()"
            />

            <OutbrainIframeBanner320Slot1 v-if="AccountController.showAds('OUTBRAIN_IFRAME_BANNER_320_SLOT_1', folder_id) && !route.query.qs"
                @removeAds="onRemoveAds()"
            />

            <GPTInlineBanner320Slot1 v-if="AccountController.showAds('GPT_INLINE_BANNER_320_SLOT_1', folder_id) && !route.query.qs"
                @removeAds="onRemoveAds()"
            />

            <ContentEmpty
                text='messages.list.empty'
                icon='fas fa-inbox'
            />

            <GPTInlineBanner320Slot2 v-if="AccountController.showAds('GPT_INLINE_BANNER_320_SLOT_2', folder_id) && !route.query.qs"
                @removeAds="onRemoveAds()"
            />
        </template>

        <template #content_loading>
          <MessagesListLoading />
        </template>
    </SectionContentLayout>

    <MessagesListSearch v-if="search_visible"
      :folder_id="folder_id"
      :messages_view="messages_view"
      :webmail_view="webmail_view"
      :viewport_controller="viewport_controller"
      @messagesSearchClose="onMessagesSearchClose()"
    />

    <MessagesListFilter v-if="filter_visible"
      :messages="messages"
      :messages_view="messages_view"
      :webmail_view="webmail_view"
      :folder_id="folder_id"
      :viewport_controller="viewport_controller"
      @messagesFilterClose="onMessagesFilterClose()"
    />

    <ContextMenu ref="context_menu_component">
        <template #menu_items>
            <MessagesContextActions
                :messages_selection='messages_selection'
                :messages_view="messages_view"
                :messages="messages"
                :zone="'context_menu_action'"
              />
        </template>
    </ContextMenu>

    <DragDrop
      ref="ref_dragdrop_message"
      event_name="drag-message-list"
      :icon="{single: 'fas fa-envelope', multiple: 'fas fa-mail-bulk'}"
      :message="{single: 'messages.move.drag_move_message', multiple: 'messages.move.drag_move_messages'}"
      :dragdrop_controller="dragdrop_controller"
    />

      <!-- <div class="list-pub-container">
      <div class="wrapper">
      <div id='div-gpt-ad-1743602898186-0' style='min-width: 300px; min-height: 50px;'>

      </div>
      </div>
      </div> -->
</template>

<script setup>
  import {ref, onMounted, nextTick}        from 'vue';
  import {onBeforeMount, onUnmounted}      from 'vue';
  import {defineEmits, reactive}           from 'vue';
  import {useRoute, useRouter}             from 'vue-router';
  import MessagesListItem                  from '../Partials/MessagesListItem.vue';
  import MessagesListCheckbox              from '../Partials/MessagesListCheckbox.vue';
  import MessagesListSearch                from '../Partials/MessagesListSearch.vue';
  import MessagesListFilter                from '../Partials/MessagesListFilter.vue';
  import MessagesListLoading               from '../Partials/MessagesListLoading.vue';
  import MessagesContextActions            from '../Partials/MessagesContextActions.vue';
  import MessagesListQuotaWarning          from '../Partials/MessagesListQuotaWarning.vue';
  import FoldersContextActions             from '@/vue/Views/Folders/Partials/FoldersContextActions.vue';
  import SectionSubHeader                  from '@/vue/Layouts/Sections/SectionSubHeader.vue';
  import SectionContentLayout              from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import InputSelectAll                    from '@/vue/Elements/Inputs/InputSelectAll.vue';
  import ActionButton                      from '@/vue/Elements/Buttons/ActionButton.vue';
  import MoreActionsDropdown               from '@/vue/Elements/DropDowns/MoreActionsDropdown.vue';
  import DropdownList                      from '@/vue/Elements/DropDowns/DropdownList.vue';
  import ContentEmpty                      from '@/vue/Elements/Content/ContentEmpty.vue';
  import ContentTitle                      from '@/vue/Elements/Content/ContentTitle.vue';
  import Swipe                             from '@/vue/Elements/Tools/Swipe.vue';
  import ContextMenu                       from '@/vue/Elements/Tools/ContextMenu.vue';
  import MessagesSelectionCollection       from '@/js/Mailboxes/Collections/MessagesSelectionCollection';
  import Language                          from '@/js/Shared/Language/Language';
  import SAPOMailConfig                    from '@/SAPOMailConfig';
  import DragDrop                          from '@/vue/Elements/Tools/DragDrop.vue';
  import PopupController                   from '@/js/Webmail/PopupController';
  import KeyboardController                from '@/js/Webmail/Keyboard/KeyboardController';
  import LayoutSettingsController          from '@/js/Webmail/LayoutSettingsController';
  import ContextMenuController             from '@/js/Webmail/ContextMenuController';
  import GTMAnalyticsController            from '@/js/Webmail/Analytics/GTMAnalyticsController';
  import FoldersController                 from '@/js/Mailboxes/FoldersController';
  import { KeyboardProfile }               from '@/js/Webmail/Keyboard/KeyboardMetadata';
  import ClientLoggingControllerSingleton  from '@/js/Webmail/ClientLogging/ClientLoggingController';
  import EventBroadcaster                  from '@/js/Common/Events/EventBroadcaster';
  import Events                            from '@/js/Common/Events/Events';
  import OutbrainIframeBanner320Slot1      from '@/vue/Views/Ads/OutbrainIframeBanner320Slot1.vue';
  import GPTIframeBanner320Slot1           from '@/vue/Views/Ads/GPTIframeBanner320Slot1.vue';
  import GPTInlineBanner320Slot1           from '@/vue/Views/Ads/GPTInlineBanner320Slot1.vue';
  import GPTInlineBanner320Slot2           from '@/vue/Views/Ads/GPTInlineBanner320Slot2.vue';
  import AccountController                 from '@/js/Webmail/AccountController';

  const limits = SAPOMailConfig.client.endpoints.context.selection_limit;

  const emit = defineEmits([
    'errorRetry'
  ])

  const props = defineProps({
    folder_id           : {},
    messages_view       : {},
    webmail_view        : {},
    messages_selection  : {},
    viewport_controller : {},
    dragdrop_controller : {},
  });

  const route                  = useRoute();
  const router                 = useRouter();
  const html_list_element      = ref();
  const context_menu_component = ref();
  const context_folder         = ref({});
  const messages               = ref({});
  const ads_visible            = ref();
  const search_visible         = ref(false);
  const filter_visible         = ref(false);
  const dummy_selection        = new MessagesSelectionCollection();
  const ref_dragdrop_message   = ref();
  const folders_warning        = {
    'TGl4bw' : true,
    'U3BhbQ' : true,
    'U2hvdHNEcm9w' : true,
  }
  onBeforeMount(() => {
    setMessages();
    setContextFolder();
  });

  onMounted(async () => {
    KeyboardController.create(KeyboardProfile.MESSAGES_ITEM_LIST, {
      move_up    : onArrowUp,
      move_down  : onArrowDown,
      select_up  : onArrowUpMeta,
      select_down: onArrowDownMeta,
      delete     : onKeyboardTrash,
    })

    props.dragdrop_controller.broadcaster.on('drag-message-list-start', onDragStart);
    props.dragdrop_controller.broadcaster.on('drag-message-list-drop-sidebar', onDragDrop);
    html_list_element.value = document.getElementsByClassName('list-group')[0];

    EventBroadcaster.on([
      [Events.VIEWPORT_UPDATED, onViewportUpdated],
    ])
  })

  onUnmounted(() => {
    props.dragdrop_controller.broadcaster.destroy('drag-message-list-start', onDragStart);
    props.dragdrop_controller.broadcaster.destroy('drag-message-list-drop-sidebar', onDragDrop);
    KeyboardController.delete(KeyboardProfile.MESSAGES_ITEM_LIST);

    EventBroadcaster.destroy([
      [Events.VIEWPORT_UPDATED, onViewportUpdated],
    ])
  })

  const onViewportUpdated = () => {
    setMessages();
    setContextFolder();
  }

  const onInvalidMessage = (index) => {

    const message = messages.value.items || [];

    ClientLoggingControllerSingleton.addEntry({
      message: message[index] || 'not defined',
      index: index,
      folder: props.folder_id,
      route: route.fullPath,
    })

    ClientLoggingControllerSingleton.onVueError('Invalid message in MessagesListSection');
  }

  const onSelectAll = () => {
    setSearchVisibility(false);
    setFilterVisibility(false);
    props.messages_view.onActionSelectAll(messages.value.index);
  }

  const onSelectReset = () => {
    props.messages_view.onActionSelectReset(messages.value.index);
  }

  const onMessagesRefresh = async () => {
    await props.viewport_controller.fetchMessages(props.folder_id, 'messages_refresh');
  }

  const onMessagesSearch = () => {
    setFilterVisibility(false);
    setSearchVisibility(!search_visible.value);
  }

  const onMessagesSearchClose = () => {
    setSearchVisibility(false);
  }

  const onMessagesSearchReset = () => {
    router.push('/messages/' + route.query.qsearchmbox)
  }

  const onMessagesFilter = () => {
    setSearchVisibility(false);
    setFilterVisibility(!filter_visible.value);
  }

  const onMessagesFilterClose = () => {
    setFilterVisibility(false);
  }

  const onMoreActionsOpen = () => {
    setSearchVisibility(false);
    setFilterVisibility(false);
  }

  const onMessagesRead = (messages_selection) => {
    props.messages_view.onActionRead(messages_selection);
  }

  const onMessagesUnread = (messages_selection) => {
    props.messages_view.onActionUnread(messages_selection);
  }

  const onMessagesMove = (messages_selection) => {
    props.messages_view.onActionMove(messages_selection);
  }

  const onMessagesDelete = (messages_selection) => {
    props.messages_view.onActionDelete(messages_selection);
  }

  const onMessageTouchDelete = (message) => {
    dummy_selection.unique(message);
    props.messages_view.onActionDelete(dummy_selection);
  }

  const onMessagesSpam = (messages_selection) => {
    props.messages_view.onActionSpam(messages_selection);
  }

  const onMessageTouchSpam = (message) => {
    dummy_selection.unique(message);
    props.messages_view.onActionSpam(dummy_selection);
  }

  const onMessagesNotSpam = (messages_selection) => {
    props.messages_view.onActionNotSpam(messages_selection);
  }

  const onMessageTouchNotSpam = (message) => {
    dummy_selection.unique(message);
    props.messages_view.onActionNotSpam(dummy_selection);
  }

  const onBlacklistEmail = () => {
    props.messages_view.onActionBlacklist(props.messages_selection);
  }

  const onWhitelistEmail = () => {
    props.messages_view.onActionWhitelist(props.messages_selection);
  }

  const onMessagesFlag = (messages_selection) => {
    props.messages_view.onActionFlag(messages_selection);
  }

  const onMessagesUnflag = (messages_selection) => {
    props.messages_view.onActionUnflag(messages_selection);
  }

  const onMessageFlag = async (message) => {
    await props.viewport_controller.flagFlagged(props.folder_id, [message.id]);
  }

  const onMessageUnflag = async (message) => {
    await props.viewport_controller.flagUnflagged(props.folder_id, [message.id]);
  }

  const onMessagesAddFilter = (messages_selection) => {
    props.messages_view.onActionAddFilter(messages_selection);
  }

  const onMessagesForward = (messages_selection) => {
    props.messages_view.onActionForward(messages_selection);
  }

  const onFoldersEmpty = () => {
    FoldersController.collection_state.setInitiator('messages_list');
    props.webmail_view.openFoldersEmpty(context_folder.value);
  }

  const onMessageSelect = ($event, message) => {
    if($event.ctrlKey || $event.shiftKey){
      return;
    }

    setMessageSelectionToggle(message);
  }

  const onBrowserNotificationClick = (data) => {
    messages.value.setOuterFocusByIndex(data.message_id);
  }

  const onMessageClick = (event, message, message_index) => {
    setMessageIndexOuterFocus(message_index);

    if(handleMessageListClick(event, message, message_index) === false){
      return;
    }

    props.messages_selection.reset();

    if (props.folder_id === SAPOMailConfig.client.folders.alias.drafts) {
      props.webmail_view.routeTo(`/compose`, {
        action: 'draft',
        mbox  : props.folder_id,
        uid   : message.id
      });
      return;
    }

    props.webmail_view.routeTo(`/messages/${props.folder_id}/${message.id}`);
  }

  const onMessageDoubleClick = (message) => {
    PopupController.open({
      path: '/messages/' + props.folder_id + '/' + message.id,
      data: {
        messages_view      : props.messages_view,
        viewport_controller: props.viewport_controller,
        folder_id          : props.folder_id,
        popup_view         : props.webmail_view,
      }
    })
  }

  const onActionClose = () => {
    router.push('/folders');
  }

  const onMessageContextMenu = (message) => {
    const message_index = messages.value.findIndex(message.id);

    context_menu_component.value.show();
    setMessageIndexOuterFocus(message_index)
    setLastOuterFocusInteration("click");

    if(ContextMenuController.event.ctrlKey || ContextMenuController.event.shiftKey){
      handleMessageListClick(ContextMenuController.event, message, message_index);
      return;
    }

    if (props.messages_selection.exists(message.id) === false) {
      props.messages_selection.unique(message);
    }
  }

  const onSelectMailbox = async () => {
    let success = await props.viewport_controller.fetchMessagesRangeList(
      props.folder_id,
      messages.value.folder_total
    );

    if (success) {
      props.messages_selection.addDummyMessages(messages.value.range_list);
    }
  }

  const onMessagesLoadMore = async () => {
    await props.viewport_controller.fetchMessagesNext(props.folder_id);
    GTMAnalyticsController.postTrackerLink('messages','messages_list','messages_load_more');
  }

  const onDragStart = (drag_item) => {
    props.dragdrop_controller.setDragOverlayElement(ref_dragdrop_message.value.$el);
    props.dragdrop_controller.setDragOverlayImage(drag_item.element_event);

    if(props.messages_selection.count === 0 && drag_item.initial_data){
      drag_item.data.add(drag_item.initial_data, drag_item.initial_data.id)
      return;
    }

    drag_item.data.addItems(props.messages_selection.index)
  }

  const onDragDrop = (drag_item) => {
    props.viewport_controller.moveMessages(
      props.folder_id,
      drag_item.drop_data,
      drag_item.data.getIndexKeys(),
    )

    props.messages_selection.reset();
  }

  const onRemoveAds = () => {
    props.webmail_view.openModal('REMOVE_ADS');
  }

  const handleMessageListClick = (event, message, message_index) => {
    if (event.shiftKey) {
      onClickShift(message_index);
      return false;
    }

    if (event.ctrlKey) {
      onClickCtrl(message);
      return false;
    }

    return true;
  };

  const setMessageSelectionToggle = (message) => {
    props.messages_selection.toggle(message.id, message);
  }

  const setMessages = () => {
    messages.value = props.viewport_controller.mailboxes.viewport.get(props.folder_id);

    (route.params.message_id)
     ? messages.value.setOuterFocusByIndex(route.params.message_id)
     : messages.value.setOuterFocus(-1);
  }

  const setContextFolder = () => {
    context_folder.value = props.viewport_controller.mailboxes.folders.all.get(props.folder_id);
  }

  const setSearchVisibility = (value) => {
    search_visible.value = value;
  }

  const setFilterVisibility = (value) => {
    filter_visible.value = value;
  }

  const resetMessageSelection = () => {
    if(props.messages_selection.count === 0){
      return;
    }

    props.messages_selection.reset();
  }

  const openMessage = (message) => {
    props.webmail_view.routeTo(`/messages/${props.folder_id}/${message.id}`);
  }

  const onKeyboardTrash = () => {
    if(props.messages_selection.count === 0 && messages.value.items[messages.value.outer_focus] === undefined){
      return;
    }

    let selection = props.messages_selection;

    if (messages.value.items[messages.value.outer_focus]) {
      selection = new MessagesSelectionCollection();
      selection.add(messages.value.items[messages.value.outer_focus]);
    }

    props.messages_view.onActionDelete(selection);
  }

  const onKeyboardOpen = () => {
    openMessage(messages.value.items[messages.value.outer_focus]);
  }

  const onArrowUp = (event) => {
    resetMessageSelection();

    if(messages.value.outerFocusUp() === false){
      return;
    }

    scrollIntoViewIfNeeded(document.getElementById(messages.value.items[messages.value.outer_focus].id))

    if (LayoutSettingsController.theme_orientation !== 'top') {
      openMessage(messages.value.items[messages.value.outer_focus]);
    }
  }

  const onArrowDown = (event) => {
    resetMessageSelection();

    if(messages.value.outerFocusDown() === false){
      return;
    }

    scrollIntoViewIfNeeded(document.getElementById(messages.value.items[messages.value.outer_focus].id))

    if (LayoutSettingsController.theme_orientation !== 'top') {
      openMessage(messages.value.items[messages.value.outer_focus]);
    }
  }

  const onArrowUpMeta = () => {
    if(messages.value.checkAndChangeLastInteration('click', 'keyboard') === true){
      resetMessageSelection();
    }

    moveSelectionFocus('up');
  }

  const onArrowDownMeta = () => {
    if(messages.value.checkAndChangeLastInteration('click', 'keyboard') === true){
      resetMessageSelection();
    }

    moveSelectionFocus('down');
  }

  const moveSelectionFocus = (direction) => {
    if (props.messages_selection.count === 0 && messages.value.outer_focus !== -1) {
      props.messages_selection.add(
        messages.value.items[messages.value.outer_focus],
     );
    }

    if (messages.value.outerFocusMove(direction) === false) {
      return;
    }

    if (props.messages_selection.count === 1
      && props.messages_selection.exists(messages.value.items[messages.value.outer_focus].id)
      && messages.value.outerFocusMove(direction) === false) {
      return;
    }

    props.messages_selection.toggle(
      messages.value.items[messages.value.outer_focus].id,
      messages.value.items[messages.value.outer_focus]
    );
  }

  const onClickShift = (message_index) => {
    const last_index = messages.value.last_outer_focus === -1 ? 0 : messages.value.last_outer_focus;
    props.messages_selection.addItemsRange(messages.value.items, last_index, message_index);
  }

  const onClickCtrl = (message) => {
    props.messages_selection.toggle(message.id, message);
  }

  const onChangeCheckbox = (event, {message, message_index}) => {
    setMessageIndexOuterFocus(message_index)
    setLastOuterFocusInteration("click");
    handleMessageListClick(event, message, message_index)
  }

  const setMessageIndexOuterFocus = (message_index) => {
    messages.value.setOuterFocus(message_index);
  }

  const setLastOuterFocusInteration = (value) => {
    messages.value.setLastOuterFocusInteration(value);
  }

  const scrollIntoViewIfNeeded = (element) => {
    if (!element) return;

    let rect = element.getBoundingClientRect();
    let is_visible = (
      (rect.top - 150) >= 0 &&
      rect.bottom <= (html_list_element.value.offsetHeight)
    );

    if (!is_visible) {
      element.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
    }
  }

</script>

<style>
  #element-list-messages {
    user-select: none;
  }
</style>
